import React, { useState } from 'react';
import {Link} from 'react-router-dom';
import {Translate} from '../../localization';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import {DESKTOP_SIDE_BAR_MENU} from '../../config/general.config';

function MenuBar(props) {
    const { hideMenuBar, showMobileSidebar, showSignUpForm, showLoginForm, isLoggedIn} = props;
    const [subNav, setSubNav] = useState(props.history.location.pathname.split('/')[2]);

    const handleClick = (item) => {
        if (subNav == item) {
            setSubNav('');
        } else {
            setSubNav(item);
        }
    }

  return (
    <Dialog className={`mob-sidebar-wrap ${showMobileSidebar ? 'active' : ''}`}  open={showMobileSidebar}  onClose={hideMenuBar}>
        <div className="mob-sidebar-content">
            <DialogTitle className="sidebar-head w-100">
                <a href="javascript:void(0);" className="sidebar-logo  w-100">
                    <img src="/images/sports/logo.png" />
                </a>
                <div className="sidebar-close"  onClick={hideMenuBar}>
                    {/* <i className="fa fa-times"></i> */}
                    <img src="/images/mob-close.png" />
                </div>
            </DialogTitle>
            <DialogContent className="sidebar-content-wrap">
                {isLoggedIn ? null : (
                    <div className='sidebar-welcome-card'>
                        <h4> Welcome to jackpotCT!</h4>
                        <p>9.3 Average rating from casino players worldwide</p>
                        <div className="welcome-btn-wrap">
                            <button className='btn btn-secondary mr-3' onClick={showLoginForm}> {Translate.login}</button>
                            <button className='btn btn-primary' onClick={showSignUpForm}> {Translate.signup}</button>
                        </div>
                    </div>
                )}
                <div className="sidebar-listing-wrap">
                    <ul>
                        <li>
                            <Link to='/casino'>
                            <a className="d-flex align-items-center">
                                <div className="list-icon">
                                    <img src="/images/cherry.png" />
                                </div>
                                <div className="list-text">
                                    <h4> {Translate.casinoGames}</h4>
                                    {/* <p>3,000+ Amazing slots to enjoy non-stop</p> */}
                                </div>                                
                            </a>
                            </Link>
                        </li>
                        {/* <li>
                            <Link to='/live-casino'>
                            <a className="d-flex align-items-center">
                                <div className="list-icon">
                                    <img src="/images/dice.png" />
                                </div>
                                <div className="list-text">
                                    <h4>{Translate.liveCasino}</h4>
                                    <p>70+ live dealers to choose from</p>
                                </div>
                            </a>
                            </Link>
                        </li>  */}
                        <li>
                        <Link to='/sports'>
                            <a className="d-flex align-items-center">
                                <div className="list-icon">
                                    <img src="/images/balls-sports.png" />
                                </div>
                                <div className="list-text">
                                    <h4> {Translate.sports}</h4>
                                    {/* <p>Check out awesome promotions every day</p> */}
                                </div>   
                            </a>
                            </Link>   

                        </li>
                        <li>
                            <Link to='/live'>
                            <a className="d-flex align-items-center">
                                <div className="list-icon">
                                    <img src="/images/live-streaming.png" />
                                </div>
                                <div className="list-text">
                                    <h4> {Translate.live}</h4>                                    
                                </div>
                            </a>
                            </Link>                        
                        </li>
                        <li>
                            <Link to='/promotion'>
                            <a className="d-flex align-items-center">
                                <div className="list-icon">
                                    <img src="/images/discount.png" />
                                </div>
                                <div className="list-text">
                                <h4> {Translate.promotion}</h4>
                                </div>
                            </a>
                            </Link>
                        </li>
                        <li>
                            <Link to='/loyalty'>
                            <a className="d-flex align-items-center">
                                <div className="list-icon">
                                    <img src="/images/sidebar-heart.png" />
                                </div>
                                <div className="list-text">
                                    <h4>{Translate.loyalty}</h4>
                                </div>
                            </a>
                            </Link>
                        </li>
                        <li>
                            <Link to='/hall-of-fame'>
                            <a className="d-flex align-items-center">
                                <div className="list-icon">
                                    <img src="/images/sidebar-trophy.png" />
                                </div>
                                <div className="list-text">
                                    <h4>{Translate.winners}</h4>
                                </div>
                            </a>
                            </Link>
                        </li>
                    </ul>      
                </div>
                {/* <div className="sidebar-listing-wrap">
                    <ul>
                        <li>
                            <a href="javascript:void(0);" className="d-flex align-items-center">
                                <div className="list-icon">
                                    <img src="/images/sidebar-logout.png" />
                                </div>
                                <div className="list-text">
                                    <h4>Logout</h4>                                    
                                </div>
                            </a>
                        </li>
                    </ul>
                </div> */}
                <div className="sidebar-listing-wrap">
                {DESKTOP_SIDE_BAR_MENU.map((item) => {
                    return (
                        <ul>
                            <div className='d-flex align-items-center bottom-linking' onClick = {()=>{handleClick(item.path.split('/')[2])}}>  
                                <div className="list-icon">
                                    <img src={item.iconSrc} alt="about-icon" />
                                </div> 
                                <h6> {item.title} </h6>
                                {(subNav == item.path.split('/')[1]) ? <i className="fas fa-chevron-up"></i> : <i className="fas fa-chevron-down"></i>}
                            </div> 
                            {(subNav == item.path.split('/')[2]) && item.subNav.map((subItem, index)=>{
                                let isActive = (subItem.path.split('/')[3] == props.history.location.pathname.split('/')[3]) ? 'active' : '';
                                return (
                                    <div className='sub-link-wrap'>
                                    <Link to={subItem.path.substring(2)}>
                                        <li id={index} >
                                            
                                                {subItem.title}
                                            
                                        </li>
                                    </Link>
                                    </div> 
                                )
                            })}
                        </ul>
                        )                        
                    })
                }           
                </div>
            </DialogContent>
        </div>
    </Dialog>
  )
}

export default MenuBar;